import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface Props {
  code: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ConfirmDeleteModal({
  code,
  onCancel,
  onConfirm,
}: Props) {
  return (
    <Dialog open={true} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Remover cupom?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Tem certeza que deseja remover o cupom <strong>{code}</strong>?
          <br />
          Esta ação não poderá ser desfeita.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Cancelar
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Remover
        </Button>
      </DialogActions>
    </Dialog>
  );
}
